import { Button, Flex, useToast } from '@chakra-ui/react';
import useToastError from 'hooks/shared/useToastError';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useCancelPeOrderMutation } from 'rtkQuery/sharespro/queries/peService';

import FullScreenLoader from 'presentation/components/shared/FullScreenLoader';
import AlertModal from 'presentation/components/shared/modals/AlertModal';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  orderId: ID;
}

const CancelPeOrderModal: FC<Props> = ({ isOpen, onClose, orderId }) => {
  const { t } = useTranslation();

  const [cancelOrder, { isLoading }] = useCancelPeOrderMutation();

  const toast = useToast();
  const toastError = useToastError();

  return (
    <>
      <AlertModal
        title={t('attention')}
        text={t('areYouSureYouWantToCancelOrder')}
        isOpen={isOpen}
        onClose={onClose}
        footer={
          <Flex>
            <Button mr={3} size="sm" onClick={onClose}>
              {t('back')}
            </Button>
            <Button
              size="sm"
              onClick={() => {
                onClose();
                cancelOrder(orderId)
                  .unwrap()
                  .then(() => {
                    toast({
                      description: t('orderWasCanceled'),
                      status: 'success',
                      position: 'top-right',
                      isClosable: true,
                    });
                  })
                  .catch((err) => {
                    toastError(err);
                  });
              }}
            >
              {t('confirm')}
            </Button>
          </Flex>
        }
      />
      <FullScreenLoader isLoading={isLoading} />
    </>
  );
};

export default CancelPeOrderModal;
